import { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

import classNames from 'classnames';

import { useDndRef } from '@iconik-io/shared-lib/src/react/hooks/use_dnd_ref';

import DraggableTypes from '../../../constants/draggable_types';
import type { FCC } from '../../../types/common';

import styles from './column_drag_source.module.css';

type Props = {
  className?: string;
  onBeginDrag: (options: { index: number }) => void;
  onEndDrag: () => void;
  index: number;
  title: string;
};

const ColumnDragSource: FCC<Props> = (props) => {
  const { className, children, index, title, onBeginDrag, onEndDrag } = props;
  const [collectedProps, dragRef, preview] = useDrag(() => ({
    type: DraggableTypes.TABLE_COLUMN,
    item: { index, title },
    end: onEndDrag,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);

  useEffect(() => {
    if (collectedProps.isDragging) {
      onBeginDrag({ index });
    }
  }, [collectedProps.isDragging, onBeginDrag, index]);

  const dragSourceRef = useDndRef(dragRef);

  return (
    <div
      className={classNames(className, styles.safe_drag_zone)}
      ref={dragSourceRef}
    >
      <div className={styles.drag_content}>{children}</div>
    </div>
  );
};

export default ColumnDragSource;
